import { StoreWasteStatistics } from "../../../models/Statistics";

export const REQUEST_STOREWASTESTATISTICS = "REQUEST_STOREWASTESTATISTICS";
export const REQUEST_STOREWASTESTATISTICS_DONE =
  "REQUEST_STOREWASTESTATISTICS_DONE";

export interface FetchStoreWasteStatistics {
  type: typeof REQUEST_STOREWASTESTATISTICS;
  payload: ReadonlyArray<StoreWasteStatistics>;
}

export interface FetchStoreWasteStatisticsDone {
  type: typeof REQUEST_STOREWASTESTATISTICS_DONE;
  payload: ReadonlyArray<StoreWasteStatistics>;
}

export interface StoreWasteStatisticsState {
  isLoading: boolean;
  storeWasteStatistics: ReadonlyArray<StoreWasteStatistics>;
}

export type StoreWasteStatisticsActions =
  | FetchStoreWasteStatistics
  | FetchStoreWasteStatisticsDone;
